import React from 'react'
import {Icon} from '@chakra-ui/react'

const SearchIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" id="search" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.1668 3.12499C8.06848 3.12499 3.12478 8.06852 3.12478 14.1667C3.12478 20.2648 8.06848 25.2083 14.1668 25.2083C20.2652 25.2083 25.2089 20.2648 25.2089 14.1667C25.2089 8.06852 20.2652 3.12499 14.1668 3.12499ZM0.208008 14.1667C0.208008 6.45769 6.45759 0.208328 14.1668 0.208328C21.8761 0.208328 28.1257 6.45769 28.1257 14.1667C28.1257 21.8756 21.8761 28.125 14.1668 28.125C6.45759 28.125 0.208008 21.8756 0.208008 14.1667Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.0009 22.9376L38.7305 36.6667L36.668 38.729L22.9385 25L25.0009 22.9376Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default SearchIcon
